module.exports = __webpack_public_path__ + "static/media/edit.ae96171b.svg";